/** One dashboard or report in a client's list: open it, see its type and whether the client can see it, delete it. */

import type { ReactNode } from 'react';

import type { DocumentKind, ReportDocument } from './reports-api.ts';

const updated = new Intl.DateTimeFormat('en-ZA', { dateStyle: 'medium' });

export const KIND_LABEL: Record<DocumentKind, string> = {
  DASHBOARD: 'Dashboard',
  SLIDE_DECK: 'Slide deck',
  DOCUMENT: 'Document',
};

export function DocumentItem({
  document,
  onOpen,
  onDelete,
}: {
  document: ReportDocument;
  onOpen: () => void;
  onDelete: () => Promise<void>;
}): ReactNode {
  return (
    <li>
      <button type="button" className="rh-item" onClick={onOpen}>
        <span className="rh-item-title">
          <strong>{document.name}</strong>
          <span className={`rh-kind rh-kind-${document.kind.toLowerCase()}`}>
            {KIND_LABEL[document.kind]}
          </span>
          {document.shared_at && <span className="rh-shared">Shared with client</span>}
        </span>
        <small>
          Updated {updated.format(new Date(document.updated_at))} · version {document.revision}
        </small>
      </button>
      <button
        type="button"
        className="linklike rh-delete"
        aria-label={`Delete ${document.name}`}
        onClick={() => {
          if (
            !window.confirm(
              `Delete “${document.name}”? Its history is kept but it disappears from this list.`,
            )
          )
            return;
          void onDelete();
        }}
      >
        Delete
      </button>
    </li>
  );
}
